module.exports = __webpack_public_path__ + "media/images/front/mid_g/banner_cs-2a8e86263e3de3821d109fb5a915a513.png";